import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  LOGIN_USER,
  LOGOUT_USER,
} from '../actions';

import { NotificationManager } from '../../components/common/react-notifications';
import {
  loginUserSuccess,
  loginUserError,
} from './actions';



import { adminRoot, loginurl, basename, currentUser } from '../../constants/defaultValues';
import { setCurrentUser } from '../../helpers/Utils';

// import { encrypt } from "../../helpers/Encrypt";

export function* watchLoginUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(LOGIN_USER, loginWithEmailPSSWD);
}

const loginWithEmailPasswordAsync = async (obj) => {
  // eslint-disable-next-line no-return-await
  return await fetch(loginurl + '/login', {
    method: 'POST', // or 'PUT'
    headers: {
      'Content-Type': 'application/json',
      // 'X-Email': btoa(obj.Email),
      // 'X-KeyPS': btoa(obj.Password),
    },
    body: JSON.stringify(obj),
    // body: JSON.stringify({}),
  })
    .then(response => response.json())
    .then(data => data)
    .catch((error) => error);
}

function* loginWithEmailPSSWD({ payload }) {
  const { history } = payload;
  try {
    if (payload.user.email == '' && payload.user.PSSWD == '') {
      yield put(loginUserError("กรุณาตรวจสอบชื่อผู้ใช้และรหัสผ่านอีกครั้ง"));
    } else {
      if (payload.user.email != '') {
        if (payload.user.email != '') {
          const obj = {
            // Email: encrypt(payload.user.email),
            // Password: encrypt(payload.user.PSSWD),
            Email: payload.user.email,
            Password: payload.user.PSSWD,
          }
          const obj2 = {
            // Email: encrypt(payload.user.email),
            // Password: encrypt(payload.user.PSSWD),
            e: btoa(payload.user.email),
            k: btoa(payload.user.PSSWD),
          }
          const res = yield call(loginWithEmailPasswordAsync, obj2);
          if (res.status == "success") {
            if (document.getElementById("savedLogin").checked == true) {
              const objsave = {
                Email: payload.user.email,
                Password: btoa(payload.user.PSSWD)
              }
              localStorage.setItem("gpfmem", JSON.stringify(objsave))
            }
            localStorage.setItem("gpfkey", res.token)
            let temp = (payload.user.email).replace('@gpf.or.th', '').charAt(0).toUpperCase() + (payload.user.email).replace('@gpf.or.th', '').slice(1)
            let splitStr = temp.toLowerCase().split('.');
            for (var i = 0; i < splitStr.length; i++) {
              splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
            }
            // Directly return the joined string
            temp = splitStr.join(' ')
            temp += '.'
            const name = temp;
            const item = { uid: (payload.user.email), id: 1, title: name, img: "https://www.freeiconspng.com/uploads/people-icon--icon-search-engine-18.png", date: new Date(), role: 0 };
            setCurrentUser(item);
            const hr = new Date().getHours()
            if (hr >= 7 && hr <= 11) {
              NotificationManager.success('Good morning, ' + item.uid, 'เข้าสู่ระบบสำเร็จ', 8000, null, null, '');
            } else if (hr >= 12 && hr <= 15) {
              NotificationManager.success('Good Afternoon, ' + item.uid, 'เข้าสู่ระบบสำเร็จ', 8000, null, null, '');
            } else {
              NotificationManager.success('Good evening, ' + item.uid, 'เข้าสู่ระบบสำเร็จ', 8000, null, null, '');
            }
            if (sessionStorage.getItem('previous') != null) {
              const link = sessionStorage.getItem('previous')
              sessionStorage.removeItem('previous')
              yield put(loginUserSuccess(item));
              history.push(link);
            }
            yield put(loginUserSuccess(item));
            history.push(adminRoot);
          } else {
            yield put(loginUserError(res.message));
          }

          //  const obj = {
          //   Email: payload.user.email,
          //   Password: btoa(payload.user.PSSWD)
          // }
          // const res = yield call(loginWithEmailPasswordAsync, obj);
          // if (payload.user.email == "gpfsurvey" && payload.user.PSSWD == 'p@ssw0rd') {
          //   if (document.getElementById("savedLogin").checked == true) {
          //     localStorage.setItem("gpfmem", JSON.stringify(obj))
          //   }
          //   // let temp = (payload.user.email).replace('@gpf.or.th', '').charAt(0).toUpperCase() + (payload.user.email).replace('@gpf.or.th', '').slice(1)
          //   // let splitStr = temp.toLowerCase().split('.');
          //   // for (var i = 0; i < splitStr.length; i++) {
          //   //     splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
          //   // }
          //   // // Directly return the joined string
          //   // temp = splitStr.join(' ')
          //   // temp += '.'
          //   const name = 'Admin';
          //   const item = {uid:(payload.user.email),id:1,title: name,img: "https://www.freeiconspng.com/uploads/people-icon--icon-search-engine-18.png",date:new Date(),role:0};
          //   setCurrentUser(item);
          //   const hr = new Date().getHours()
          //   if (hr >= 7 && hr <= 11) {
          //     NotificationManager.success('Good morning, ' + item.title, 'เข้าสู่ระบบสำเร็จ', 8000, null, null, '');
          //   } else if (hr >= 12 && hr <= 15) {
          //     NotificationManager.success('Good Afternoon, ' + item.title, 'เข้าสู่ระบบสำเร็จ', 8000, null, null, '');
          //   } else {
          //     NotificationManager.success('Good evening, ' + item.title, 'เข้าสู่ระบบสำเร็จ', 8000, null, null, '');
          //   }
          //   yield put(loginUserSuccess(item));
          //   if (sessionStorage.getItem('previous') != null) {
          //     const newpath = (new URL(sessionStorage.getItem('previous')).pathname).replace(basename + adminRoot, adminRoot)
          //     sessionStorage.removeItem('previous')
          //     history.push(newpath)
          //   } else {
          //     history.push(adminRoot);
          //   }
        } else {
          yield put(loginUserError("กรุณาตรวจสอบที่อยู่อีเมล์และรหัสผ่านอีกครั้ง"));
        }
      } else {
        yield put(loginUserError("Unknown error"));
      }
    }
  } catch (error) {
    yield put(loginUserError(error));
  }
}

export function* watchLogoutUser() {
  // eslint-disable-next-line no-use-before-define
  yield takeEvery(LOGOUT_USER, logout);
}

const logoutAsync = async (history) => {
  history.push(adminRoot);
};

function* logout({ payload }) {
  const { history } = payload;
  setCurrentUser();
  yield call(logoutAsync, history);
}

export default function* rootSaga() {
  yield all([
    fork(watchLoginUser),
    fork(watchLogoutUser)
  ]);
}
